import { createContext } from 'react';

const commonContext = createContext({
  user: {},
  buttonMap: {},
});

export const { Provider, Consumer } = commonContext;
export default commonContext;
